/** @jsxImportSource @emotion/react */
import { useRef, useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { SubTitleLayout, SubTitleGroup, ControlBtnGroup } from 'components/layouts/ContentLayout';
import CustomDialog from 'components/modals/common/CustomDialog';
import { IconButton } from 'components/buttons/IconSVG';
import { useMessageBar } from 'hooks/useMessageBar';
import { useLoading } from 'components/process/Loading';
import { tb } from 'components/layouts/Table';

type Props = {
  open: boolean;
  close: () => void;
};

/**
 * 유사 모델 조회 팝업
 */
const ModelSimilityPopup = ({ open, close, ...props }: Props) => {
  const { t } = useTranslation();
  const { openMessageBar } = useMessageBar();
  const { openLoading } = useLoading();

  const [rowData, setRowData] = useState<any>([]);

  const btnSave = () => {
    // save
  };

  useEffect(() => {
    //
  }, []);

  const dialogButtons = [
    <Button
      key={'confirm'}
      css={IconButton.button}
      className="confirm"
      onClick={btnSave}
      disableRipple
    >
      {t('com.button.유사모델 저장', '유사모델 저장')}
    </Button>,
  ];
  return (
    <CustomDialog
      title={String(t('setup.label.유사모델 조회', '유사모델 조회'))}
      size={'lg'}
      open={open}
      onClose={close}
      buttons={dialogButtons}
    >
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('setup.label.유사모델', '유사모델')}</h3>
        </SubTitleGroup>
      </SubTitleLayout>
      <TableContainer css={tb.tableCol} className="flex">
        <Table style={{ flex: 2 }}>
          <TableHead>
            <TableRow>
              <TableCell className="HdBg" colSpan={2}>
                구분
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className="HdBg" colSpan={2}>
                셀 Type
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="HdBg" rowSpan={7}>
                완성 Cell
              </TableCell>
              <TableCell className="HdBg">조성</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="HdBg">양/단 방향</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="HdBg">용량</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="HdBg">전장</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="HdBg">전폭</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="HdBg">두께</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="HdBg">Stack 수</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="HdBg">PKG</TableCell>
              <TableCell className="HdBg">3면/4면</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="HdBg">EOL</TableCell>
              <TableCell className="HdBg">Folding Type</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="HdBg" colSpan={2}>
                유사도
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Table style={{ flex: 3 }}>
          <TableHead>
            <TableRow>
              <TableCell colSpan={3}>H5.5A</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Spec</TableCell>
              <TableCell>GAP</TableCell>
              <TableCell>점수</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array(11).map((o, i) => {
              return (
                <TableRow key={i}>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Table style={{ flex: 2 }}>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>E66C</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Spec</TableCell>
              <TableCell>GAP</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array(11).map((o, i) => {
              return (
                <TableRow key={i}>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Table style={{ flex: 2 }}>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>E81B</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Spec</TableCell>
              <TableCell>GAP</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array(11).map((o, i) => {
              return (
                <TableRow key={i}>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </CustomDialog>
  );
};

export default ModelSimilityPopup;
